<div style="min-height: 50vh;">
    <!--    <div class="col-12 navicat">-->
    <!--        <div *ngIf="getDirection()=='rtl'"><span (click)="goToPageList()">{{topNavigationText}}</span> <span-->
    <!--                class="pi pi-angle-left">  </span> <span> {{page.name}}</span></div>-->
    <!--        <div *ngIf="getDirection()=='ltr'"><span (click)="goToPageList()">{{topNavigationText}}</span> <span-->
    <!--                class="pi pi-angle-right">  </span> <span> {{page.name}}</span></div>-->
    <!--    </div>-->
    <div class="header-svg">
        <svg width="657" height="627" viewBox="0 0 657 627" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1582.41" y="-1007" width="761.879" height="1865.11" rx="380.94"
                  transform="rotate(58.0414 1582.41 -1007)" stroke="url(#paint0_linear_853_14385)" stroke-width="3"/>
            <rect x="1538.7" y="-818.295" width="487.945" height="1591.17" rx="243.973"
                  transform="rotate(58.0414 1538.7 -818.295)" stroke="url(#paint1_linear_853_14385)" stroke-width="2"/>
            <rect x="1494.99" y="-629.591" width="214.011" height="1317.24" rx="107.006"
                  transform="rotate(58.0414 1494.99 -629.591)" stroke="url(#paint2_linear_853_14385)"/>
            <defs>
                <linearGradient id="paint0_linear_853_14385" x1="2057.88" y1="996.448" x2="2069.78" y2="387.196"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#5200FF"/>
                    <stop offset="1" stop-color="#00C8BC"/>
                </linearGradient>
                <linearGradient id="paint1_linear_853_14385" x1="1888.82" y1="1039.67" x2="1884.92" y2="442.806"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#5200FF"/>
                    <stop offset="1" stop-color="#00C8BC"/>
                </linearGradient>
                <linearGradient id="paint2_linear_853_14385" x1="1736.14" y1="1064.73" x2="1703.55" y2="489.985"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#5200FF"/>
                    <stop offset="1" stop-color="#00C8BC"/>
                </linearGradient>
            </defs>
        </svg>
    </div>
    <div class="page-body success-body col-12 flex centerWidth" (click)="pageClick($event,sInx)">

        <div class="col-12 {{indexList.length>0 && page.showIndex ?'lg:col-8':'lg:col-12'}} ">
            <div class="block lg:flex" >
                <div class="col-12 {{ page.style.bgImage != null && page.style.bgImage.length>0 ? 'lg:col-6' : '' }} txt-pnl">
                    <div style="display: flex">
                        <div class="img" *ngIf="page.style.logoImage!= null && page.style.logoImage.length>0">
                            <img style="margin: 2px 10px;width: 60px;height: 60px;"
                                 [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.logoImage ">
                        </div>
                        <div>
                            <div *ngIf="pageType=='NEWS'" style="color: #81868E;">{{(page.lastUpdate!=null || page.lastUpdate>0 ? page.lastUpdate : page.createDate) |dateText:'dd mmm yyyy' |numberText}}</div>
                            <h2 *ngIf="page.title != null && page.title.length>0"  style="font-size: 35px; margin: 12px 15px;">
                                {{page.title}}
                            </h2>
                        </div>
                    </div>
                    <div *ngIf="page.summary != null && page.summary.length>5"  style="    height: calc(100% - 80px);margin: 0px 0px;">
                        <p style="    margin: 0px 3px;">
                            {{page.summary}}
                        </p>
                    </div>
                </div>
                <div *ngIf="page.style.bgImage != null && page.style.bgImage.length>0" class="col-12 lg:col-6 img-pnl">
                    <img [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +page.style.bgImage ">
                </div>
            </div>
            <section *ngFor="let section of page.pageSections; let j=index">
                <ng-container *ngFor="let item of section.items; let i=index">
                    <div class=" {{item.display_mode==null?'': item.display_mode=='lg'?'md:hidden-item sm:hidden-item':item.display_mode=='md'?'lg:hidden-item sm:hidden-item':item.display_mode=='sm'?' lg:hidden-item md:hidden-item':''}} "
                         style="margin-top: 20px;z-index: 2;">
                        <div class="flex" *ngIf="item.type=='TITLE'">
                            <img style="margin: 10px 0px;width: 50px;height: 50px;"
                                 *ngIf="item.body['imgUid']!= null && item.body['imgUid'].length>0 "
                                 [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +item.body['imgUid'] ">
                            <h2 style="margin-top: 13px;" id="{{j+''+i}}"
                                class="section-title">{{item.body['text']}}</h2>
                        </div>
                        <div *ngIf="item.type=='TEXT'" [innerHtml]="item.body['text'] |safeHtmlPipe"></div>
                        <div *ngIf="item.type=='HTML'" [innerHtml]="item.body['code']"></div>

                        <div *ngIf="item.type=='AUTHOR'" class="author flex">
                            <img [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +item.body['imgUid'] ">
                            <div>{{item.body['name']}}</div>
                            <div> -</div>
                            <div>{{item.body['desc']}}</div>
                        </div>

                        <video *ngIf="item.type=='VIDEO'" width="100%" controls>
                            <source src="{{item.body['src']}}"
                                    type="video/mp4">
                        </video>

                        <img *ngIf="item.type=='PHOTO'" style="width: 100%;"
                             [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +item.body['imgUid'] "
                             [alt]="item.body['name']"/>

                        <div *ngIf="item.type=='SEPARATOR'" class="separator"></div>
                        <div *ngIf="item.type=='ACCORDION'">
                            <p-accordion>
                                <p-accordionTab *ngFor="let accordi of item.body['list']; let i=index "
                                                [header]="accordi['title']">
                                    <p>
                                        {{accordi['text']}}
                                    </p>
                                </p-accordionTab>
                            </p-accordion>
                        </div>
                        <div *ngIf="item.type=='INNER'" [innerHTML]="item.body['code'] |safeHtmlPipe"></div>
                    </div>
                </ng-container>
            </section>
        </div>
        <div id="side-index" [hidden]="indexList.length<1 " class="side-index  col-12 lg:col-4 {{!page.showIndex? 'hidden':''}} ">
            <div>
                <div class="font-bold flex " (click)="toggelSideIndex(sInx)">
                    <div class="col-10" i18n="@@You read in this page"> You read in this page</div>
                    <div style="text-align: end;" class="block md:hidden col-2 pi
                        {{sInx.classList.contains('hidden') ? ( getDirection()=='rtl' ? 'pi-angle-left' : 'pi-angle-right') :'pi-angle-down' }}  "
                         ></div>
                </div>
                <div #sInx class="hidden lg:block">
                    <ul>
                        <li id="{{'li_'+item.id}}" *ngFor="let item of indexList"
                            (click)="goToFregment(item.id);toggelSideIndex(sInx);">
                            <div>&nbsp;</div>
                            <span>{{item.value}}</span></li>
                    </ul>

                        <button  class="button darkblue" (click)="goToDashboard()">
                            <span i18n="@@Start Free">Start Free</span>
                            <i class="pi pi-angle-left"></i>
                        </button>

                </div>
            </div>


        </div>
    </div>

</div>
